import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../api/Api';
import parse from 'html-react-parser';
import Footer from './Footer';
import Header from './Header';
import useApiRequest from '../api/ApiRequest';

const DynamicPage = () => {
    const request = useApiRequest();

    const [headerFooterData, setHeaderFooterData] = useState([]);

    const { slug } = useParams();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        request({
            method: "get",
            url: api.HEADER_FOOTER,
        })?.then((response) => {
            setHeaderFooterData(response);
        });
    }, []);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                setLoading(true);
                // Get the base URL from the existing API endpoints
                const baseUrl = api.HOME_PAGE.split('?')[0];
                const response = await axios.get(`${baseUrl}?slug=${slug}`);
                if (response.data && response.data.length > 0) {
                    setPageData(response.data[0]);
                } else {
                    // Instead of showing error, redirect to 404 page
                    navigate('/404');
                }
            } catch (err) {
                // On API error, redirect to 404 page
                navigate('/404');
                console.error('Error fetching page:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchPage();
    }, [slug, navigate]);

    if (loading) {
        return (
            <div>
                <Header logo={headerFooterData?.site_logo?.url} content={headerFooterData} />
                <section className="header-space m-b-50 p-t-50">
                    <div className="container">
                        <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>
                            Loading...
                        </div>
                    </div>
                </section>
                <Footer
                    logo={headerFooterData?.site_logo?.url}
                    leftContent={headerFooterData?.footer_left_side_content}
                    copyRightText={headerFooterData?.footer_copyright_text}
                    socialIcons={headerFooterData?.site_social_icons}
                    copyRightMenu={headerFooterData?.footer_copyright_menu}
                    footerMenu={headerFooterData?.footer_right_side_content?.menus}
                    newsLetterContent={headerFooterData?.footer_right_side_content?.news_latter}
                    poweredBy={headerFooterData?.powered_by}
                />
            </div>
        );
    }

    if (!pageData) {
        return null; // Return null since we're redirecting
    }

    return (
        <div>
            <Header logo={headerFooterData?.site_logo?.url} content={headerFooterData} />
            <section className="header-space m-b-50 p-t-50">
                <div className="container">
                    <h1 className="section-heading">{pageData.title.rendered}</h1>
                    <div dangerouslySetInnerHTML={{ __html: pageData.content.rendered }}></div>
                </div>
            </section>
            <Footer
                logo={headerFooterData?.site_logo?.url}
                leftContent={headerFooterData?.footer_left_side_content}
                copyRightText={headerFooterData?.footer_copyright_text}
                socialIcons={headerFooterData?.site_social_icons}
                copyRightMenu={headerFooterData?.footer_copyright_menu}
                footerMenu={headerFooterData?.footer_right_side_content?.menus}
                newsLetterContent={headerFooterData?.footer_right_side_content?.news_latter}
                poweredBy={headerFooterData?.powered_by}
            />
        </div>
    );
};

export default DynamicPage;